import { render, staticRenderFns } from "./LocationInfoTable.vue?vue&type=template&id=27a12ce8"
import script from "./LocationInfoTable.vue?vue&type=script&lang=js"
export * from "./LocationInfoTable.vue?vue&type=script&lang=js"
import style0 from "./LocationInfoTable.vue?vue&type=style&index=0&id=27a12ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports